'use strict';

var React = require('react');

var SvgCameraMajor = function SvgCameraMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.74 1.786a1.5 1.5 0 0 1 1.319-.786h5.855a1.5 1.5 0 0 1 1.315.777l.55 1c.04.074.073.148.1.223h3.621a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-17a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h3.603c.025-.072.057-.144.095-.214l.542-1zm-3.74 3.214h3v2h-3v-2zm12 5a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"
  }));
};

exports.SvgCameraMajor = SvgCameraMajor;
